(function ($) {
  $(document).ready(function () {
    $(".accordion .accordion-item h3").click(function () {
      if ($(this).parent().hasClass("active")) {
        $(".accordion-item").removeClass("active");
        $(".accordion-item").children(".pannel").slideUp();
      } else {
        $(".accordion-item").removeClass("active");
        $(this).parent().addClass("active");
        $(".accordion-item").find(".pannel").slideUp();
        $(this).parent().children(".pannel").slideDown();
      }
    });
    $(document).on("click", ".accordion .arrow1", function () {
      $(this).addClass("active");
      $(this).removeClass("active");
    });
  });
})(jQuery);
